module.exports = __webpack_public_path__ + "img/21_rain.801e763f.jpg";